import React from 'react';

interface Props {
    order: any;
}

const getOrderConditionReceiptPageMessageHtmlByOrder = (order) => {
    const messageCondition = order.conditions.find((condition) => condition.name === 'showReceiptMessage');
    if (messageCondition && messageCondition.attributes && messageCondition.attributes.messageHtml) {
        return messageCondition.attributes.messageHtml;
    }
    return null;
};

/**
 * @deprecated - use ContentAreaDisplay instead
 */
const ReceiptOrderConditionMessage = ({ order }: Props) => {
    const message = getOrderConditionReceiptPageMessageHtmlByOrder(order);
    return <>
        {message &&
            <div dangerouslySetInnerHTML={{ __html: message }} />
        }
    </>;
};

export default ReceiptOrderConditionMessage;
